import { useHistory, useLocation } from "react-router-dom";
import { setActiveAccount, updateTooltip } from "api";
import { useEffect } from "react";

const useSwitchWorkspace = (
  active_account,
  accounts,
  setBrandDetails,
  user
) => {
  const router = useHistory();
  const { pathname, search } = useLocation();

  const getSavedAccountId = async () => {
    const account_id = localStorage.getItem("account_id");
    const account1 = accounts && accounts[0];
    const tempAccount = accounts?.find(
      (item) => item?.id === parseInt(account_id)
    );

    if (tempAccount) {
      setActiveAccount(tempAccount);
    } else {
      setActiveAccount(account1);
    }
    // getBrands()

    savePathName();
  };

  const savePathName = async () => {
    if (!active_account?.id) return;
    
    // if user is not owner of account
    if (active_account?.owner.id === user?.id) {
      // For new user that did not go through onboarding, complete the onboarding without saving the path
      if (!user?.has_viewed_tooltips?.onboarding_completed) {
        // complete onboarding
        await updateTooltip({
          ...user?.has_viewed_tooltips,
          onboarding_completed: true,
        });
      }
      return;
    }

    localStorage.setItem(
      `savedPathName_${active_account?.id}`,
      `${pathname}${search}`
    );
  };

  const saveAccountId = (account) => {
    if (!account.id || account.id === active_account?.id) return;

    setBrandDetails(null);

    localStorage.setItem("account_id", account.id);

    const savedPathName = localStorage.getItem(`savedPathName_${account.id}`);

    router.push(savedPathName || "/dashboard/home");

    getSavedAccountId();
  };

  useEffect(() => {
    getSavedAccountId();
    // eslint-disable-next-line
  }, [accounts]);

  useEffect(() => {
    savePathName();
    // eslint-disable-next-line
  }, [accounts]);

  return { saveAccountId };
};

export default useSwitchWorkspace;
